import clsx from 'clsx'
import Image from 'next/image'
import { useMemo } from 'react'

/* blocks */
import Link from '@/atoms/Link/Link'
import Carousel from '@/cmp/templates/VideoMarketing/components/Carousel/Carousel'

/* utils */
import { ContentMarketingLeaders2025Attributes } from '@/utils/queries/gml_2025'

interface Props {
  title: string
  titleClass?: string
  bgColor?: string
  lists: ContentMarketingLeaders2025Attributes[]
}

function Episodes({ title, titleClass, bgColor, lists }: Props) {
  const slides = useMemo(() => {
    return lists.map(list => <Slide key={list.slug} list={list} />)
  }, [lists])

  const hasPastEpisode = lists.some(list => list.episodeType === 'Past_Episode')
  const buttonConfig = hasPastEpisode
    ? {
        prevButtonClassName: 'text-gray-90',
        nextButtonClassName: 'text-gray-90'
      }
    : undefined

  return (
    <section className={clsx(bgColor)}>
      <div className="relative">
        <div className="container | py-10 md:py-18 relative z-10">
          <h2
            className={clsx(
              titleClass ?? 'text-3xl lg:text-5xl font-semibold text-white'
            )}
          >
            {title}
          </h2>
        </div>
        <div className="md:pb-18">
          <Carousel
            navigationType="arrow"
            sliderClassName="mb-10 md:first:ml-10 px-4 md:px-0"
            slideStyle={{ width: '100%', maxWidth: '530px' }}
            buttonConfig={buttonConfig}
            slides={slides}
          />
        </div>
      </div>
    </section>
  )
}

const Slide = ({ list }: { list: ContentMarketingLeaders2025Attributes }) => {
  return list.episodeType === 'Past_Episode' ? (
    <Link key={list.slug} href={`/global-marketing-leaders-2025/${list.slug}/`}>
      <div className="snap-center | relative">
        <div className="flex flex-col | text-left rounded-xl">
          <div className="relative">
            <Image
              src={list.thumbnailImage.data.attributes.url ?? ''}
              alt={list.thumbnailImage.data.attributes.alternativeText ?? ''}
              height={list.thumbnailImage.data.attributes.height}
              width={list.thumbnailImage.data.attributes.width}
              className="object-cover md:w-full"
            />
          </div>
        </div>
      </div>
    </Link>
  ) : (
    <div key={list.slug} className="snap-center | relative">
      <div className="flex flex-col | text-left rounded-xl">
        <div className="relative">
          <Image
            src={list.thumbnailImage.data.attributes.url ?? ''}
            alt={list.thumbnailImage.data.attributes.alternativeText ?? ''}
            height={list.thumbnailImage.data.attributes.height}
            width={list.thumbnailImage.data.attributes.width}
            className="object-cover md:w-full"
          />
        </div>
      </div>
    </div>
  )
}

export default Episodes
